import axios from "axios";
import API from "./API";
import Endpoints from "@/V3/Config/Endpoints";

export default {


    deleteContractorAccess(centre_id, access_group) {
        return axios.delete(
            API.url(Endpoints.Access.DeleteContractorAccess, {centre_id, access_group})
        ).then((res) => res.data.message);
    },

    fetchAvailableTypes() {
        return axios.get(
            API.url(Endpoints.Access.AvailableTypes)
        ).then((res) => {
            return res.data.types;
        });
    },

    fetchApprovalRequests(centreId, url) {
        let getUrl = url ? url : API.url(Endpoints.Access.FetchApprovalRequests, {centre_id: centreId});
        return axios.get(getUrl).then((res) => {
            return res.data.requests;
        });
    },
    getApprovalRequest(id) {
        let getUrl = API.url(Endpoints.Access.GetApprovalRequest, {request_id: id});
        return axios.get(getUrl).then((res) => {
            return res.data.requests;
        });
    },

    searchApprovalRequests(centreId, query, types) {
        return axios.get(
            API.url(Endpoints.Access.SearchApprovalRequests + '?q='
                + encodeURIComponent(query)
                + '&types=' + encodeURIComponent(types),
                {centre_id: centreId})
        ).then((res) => {
            return res.data.requests;
        });
    },

    searchContractorAccess(centreId, query, type, page) {
        const params = {
            page,
            q: query,
            role: type
        };
        return axios.get(
            API.url(Endpoints.Access.SearchContractorAccess,{centre_id: centreId}),
            {
                params
            }
        ).then((res) => {
            return res.data;
        });
    },

    fetchForBooking(bookingID) {

        return axios.get(
            API.url(Endpoints.Access.FetchForBooking, {booking_id: bookingID})
        ).then((res) => {
            return res.data.employees;
        });

    },

    toggleForBooking(bookingID, userID, shouldHaveAccess) {

        return axios.patch(
            API.url(Endpoints.Access.ToggleForBooking, {booking_id: bookingID}),
            {user_id: userID, should_have_access: shouldHaveAccess}
        ).then((res) => {
            return res.data;
        });

    },

    toggleForBookingEmployees(bookingID, userIDs, shouldHaveAccess) {
        return axios.patch(
            API.url(Endpoints.Access.ToggleForBookingEmployees, {booking_id: bookingID}),
            {user_ids: userIDs, should_have_access: shouldHaveAccess}
        ).then((res) => {
            return res.data;
        });
    },

    getMaxCustomAccessDate(centreId, companyId) {
        return axios.get(
            API.url(Endpoints.Access.GetMaxCustomAccessDate, {centre_id: centreId, company_id: companyId})
        ).then((res) => res.data);
    }
}
